import { render, staticRenderFns } from "./traceButton.vue?vue&type=template&id=ffe2a034&"
import script from "./traceButton.vue?vue&type=script&lang=js&"
export * from "./traceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports